<template>
  <div>
    <p class="date-content">{{ published_date }}</p>
    <p 
      class="news-content blue-security font-weight-bold"
      v-if="$vuetify.breakpoint.smAndDown"
    >{{ title }}</p>
    
    <p v-html="content" align="justify" class="news-content"></p>
  </div>
</template>

<script>
export default {
  props: {
    content: {
      type: String,
      required: false
    },
    published_date: {
      type: String,
      required: false
    },
    post_type: {
      type: String,
      required: false
    },
    title: {
      type: String,
      required: false
    }
  },
  computed: {

  }
}
</script>

<style>
.news-content img {
  max-width: 100%;
  height: auto;
}

.news-content iframe {
  max-width: 100%;
}

.news-content video {
  max-width: 100%;
}

.date-content {
  color: #9d9d9c;
}
</style>